<!--  section  -->
<section class="parallax-section single-par" data-scrollax-parent="true">
    <div class="bg par-elem " style="background-image: url('../../assets/images/bg/2.jpg'); translate:'30%'"></div>
    <div class="overlay op7"></div>
    <div class="container">
        <div class="section-title center-align big-title">
            <h2><span>Our Business Plans</span></h2>
            <span class="section-separator"></span>
            <div class="breadcrumbs fl-wrap"><a href="/">Home</a><span>Pricing Tables</span></div>
        </div>
    </div>
    <div class="header-sec-link">
        <a href="javascript:void(0);" class="custom-scroll-link"><i class="fal fa-angle-double-down"></i></a>
    </div>
</section>
<!--  section  end-->
<section id="sec1" data-scrollax-parent="true">
    <div class="container">
        <div class="section-title">
            <h2> Pricing Tables</h2>
            <div class="section-subtitle">Cost of our services</div>
            <span class="section-separator"></span>
        </div>
        <div class="pricing-switcher">
            <div class="fieldset color-bg">
                <input type="radio" name="duration-1" id="monthly-1" class="tariff-toggle" disabled>
                <label for="monthly-1" disabled>Monthly Business Plan</label>
                <input type="radio" name="duration-1" class="tariff-toggle" id="yearly-1" checked>
                <label for="yearly-1">Year Business Plan</label>
                <span class="switch"></span>
            </div>
        </div>
        <div class="pricing-wrap fl-wrap">
            <!-- price-item-->
            <div class="price-item">
                <div class="price-head  purp-gradient-bg">
                    <h3>Basic</h3>
                    <div class="price-num col-dec-1 fl-wrap">
                        <div class="price-num-item">
                            <span class="mouth-cont" style="text-decoration: line-through; font-size: 40px; color: #999;"><span class="curen">₹</span>700 </span>
                            <span class="mouth-cont"><span class="curen">₹</span>299 </span>
                        </div>
                        <div class="clearfix"></div>
                        <div class="price-num-desc d-none">
                            <span class="mouth-cont">1 Year</span>
                            <span class="year-cont">5 Year</span>
                        </div>
                    </div>
                    <div class="circle-wrap" style="right:20%;top:50px;">
                        <div class="circle_bg-bal circle_bg-bal_versmall" data-scrollax="properties: { translateY: '50px' }"></div>
                    </div>
                    <div class="circle-wrap" style="right:75%;top:90px;">
                        <div class="circle_bg-bal circle_bg-bal_versmall"></div>
                    </div>
                    <div class="footer-wave">
                        <svg viewbox="0 0 100 25">
                                    <path fill="#fff" d="M0 30 V12 Q30 17 55 12 T100 11 V30z" />
                                </svg>
                    </div>
                    <div class="footer-wave footer-wave2">
                        <svg viewbox="0 0 100 25">
                                    <path fill="#fff" d="M0 90 V12 Q30 7 45 12 T100 11 V30z" />
                                </svg>
                    </div>
                </div>
                <div class="price-content fl-wrap">
                    <div class="price-desc fl-wrap">
                        <ul class="no-list-style">
                            <li>Business listing</li>
                            <li>Business enquiry</li>
                            <li>Set Map location</li>
                            <li>Business Review / Feeds / Messages</li>
                            <li>Profile info view/edit</li>
                            <li>Set profile image and social links</li>
                            <li>Working hours support</li>
                            <li>SMS / Emailer notification</li>
                            <li>2 Slider photos upload facility</li>
                            <li>2 Extra items upload facility</li>
                            <li>No Ads campaign facility</li>
                            <li>No Product seller facility</li>
                        </ul>
                        <span class="mouth-cont hide" (click)="payWithPhonepay(10,'Basic')"> 
                            Test Pay Now
                        </span>
                        <div class="price-num col-dec-1 fl-wrap green-bg">
                            <div class="price-num-item">
                                <span class="mouth-cont" (click)="payWithPhonepay(299,'Basic')"> 
                                    Pay Now
                                </span>
                                <span class="year-cont hide" (click)="payWithPhonepay(299,'Basic')">   
                                    Pay Now
                               </span>
                            </div>
                            <div class="clearfix"></div>
                            <div class="price-num-desc">
                                <span class="mouth-cont">1 Year</span>
                                <span class="year-cont">5 Year</span>
                            </div>
                        </div>

                    </div>
                </div>
            </div>
            <!-- price-item end-->
            <!-- price-item-->
            <div class="price-item best-price">
                <div class="price-head   gradient-bg">
                    <h3>Extended</h3>
                    <div class="price-num col-dec-2 fl-wrap">
                        <div class="price-num-item">
                            <span class="mouth-cont">
                                <span class="curen">₹</span>1,200</span>
                                <span class="year-cont"><span class="curen">₹</span>1,200</span>
                        </div>
                        <div class="clearfix"></div>
                        <div class="price-num-desc d-none">
                            <span class="mouth-cont">1 Year</span>
                            <span class="year-cont">5 Year</span>
                        </div>
                    </div>
                    <div class="circle-wrap" style="right:20%;top:70px;">
                        <div class="circle_bg-bal circle_bg-bal_versmall"></div>
                    </div>
                    <div class="circle-wrap" style="right:70%;top:40px;">
                        <div class="circle_bg-bal circle_bg-bal_versmall" data-scrollax="properties: { translateY: '-150px' }"></div>
                    </div>
                    <div class="footer-wave">
                        <svg viewbox="0 0 100 25">
                                    <path fill="#fff" d="M0 60 V2 Q30 17 55 12 T100 11 V30z" />
                                </svg>
                    </div>
                    <div class="footer-wave footer-wave2">
                        <svg viewbox="0 0 100 25">
                                    <path fill="#fff" d="M0 90 V16 Q30 7 45 12 T100 5 V30z" />
                                </svg>
                    </div>
                </div>
                <div class="price-content fl-wrap">
                    <div class="price-desc fl-wrap">
                        <ul class="no-list-style"> 
                            <li>Business listing</li>
                            <li>Business enquiry</li>
                            <li>Set Map location</li>
                            <li>Business Review / Feeds / Messages</li> 
                            <li>Profile info view/edit</li>
                            <li>Set profile image and social links</li>
                            <li>Working hours support</li>
                            <li>SMS / Emailer notification</li>
                            <li>3 Slider photos upload facility</li>
                            <li>3 Extra items upload facility</li>
                            <li>2 Ads campaign facility</li>
                            <li>1 Product seller facility</li>
                            <li>Socials share featured</li>
                            <li>Banner advertising featured </li>
                            <li>Lifetime availability</li>
                            <li>Featured in search results</li>
                        </ul>

                        <div class="price-num col-dec-1 fl-wrap green-bg">
                            <div class="price-num-item">
                                <span class="mouth-cont" (click)="payWithPhonepay(1200,'Extended')"> 
                                    Pay Now
                                </span>
                                <span class="year-cont hide" (click)="payWithPhonepay(1200,'Extended')">   
                                    Pay Now
                               </span>
                            </div>
                            <div class="clearfix"></div>
                            <div class="price-num-desc">
                                <span class="mouth-cont">1 Year</span>
                                <span class="year-cont">5 Year</span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <!-- price-item end-->
            <!-- price-item-->
            <div class="price-item">
                <div class="price-head green-gradient-bg  ">
                    <h3>Professional</h3>
                    <div class="price-num col-dec-1 fl-wrap">
                        <div class="price-num-item">
                            <span class="mouth-cont">
                                <span class="curen">₹</span>2,000</span>
                                <span class="year-cont"><span class="curen">₹</span>2,000
                            </span>
                        </div>
                        <div class="clearfix"></div>
                        <div class="price-num-desc d-none">
                            <span class="mouth-cont">1 Year</span>
                            <span class="year-cont">5 Year</span>
                        </div>
                    </div>
                    <div class="circle-wrap" style="right:20%;top:50px;">
                        <div class="circle_bg-bal circle_bg-bal_versmall" data-scrollax="properties: { translateY: '50px' }"></div>
                    </div>
                    <div class="circle-wrap" style="right:75%;top:90px;">
                        <div class="circle_bg-bal circle_bg-bal_versmall"></div>
                    </div>
                    <div class="footer-wave">
                        <svg viewbox="0 0 100 25">
                                    <path fill="#fff" d="M0 30 V12 Q30 17 55 12 T100 11 V30z" />
                                </svg>
                    </div>
                    <div class="footer-wave footer-wave2">
                        <svg viewbox="0 0 100 25">
                                    <path fill="#fff" d="M0 90 V12 Q30 7 45 12 T100 11 V30z" />
                                </svg>
                    </div>
                </div>
                <div class="price-content fl-wrap">
                    <div class="price-desc fl-wrap">
                        <ul class="no-list-style">
                            <li>Business listing</li>
                            <li>Business enquiry</li>
                            <li>Set map location</li>
                            <li>Business Review / Feeds / Messages</li>
                            <li>Product Review / Feeds / Messages</li>
                            <li>Profile info view/edit</li>
                            <li>Set profile image and social links</li>
                            <li>Working Hours support</li>
                            <li>SMS / Emailer notification</li>
                            <li>4 Slider photos upload facility</li>
                            <li>4 Extra items upload facility</li>
                            <li>3 Ads campaign facility</li>
                            <li>5 Product seller facility</li>
                            <li>Socials share featured</li>
                            <li>Banner advertising featured </li>
                            <li>Lifetime availability</li>
                            <li>Direct business enquiry</li>
                            <li>Direct product selling enquiry</li>
                            <li>Order listing</li>
                            <li>Lifetime availability</li>
                            <li>Featured in search results</li>
                        </ul>
                        <div class="price-num col-dec-1 fl-wrap green-bg">
                            <div class="price-num-item">
                                <span class="mouth-cont" (click)="payWithPhonepay(2000,'Professional')"> 
                                    Pay Now
                                </span>
                                <span class="year-cont hide" (click)="payWithPhonepay(2000,'Professional')">   
                                    Pay Now
                               </span>
                            </div>
                            <div class="clearfix"></div>
                            <div class="price-num-desc">
                                <span class="mouth-cont">1 Year</span>
                                <span class="year-cont">5 Year</span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <!-- price-item end-->
        </div>
        <span class="section-separator"></span>
        <!-- features-box-container -->
        <div class="features-box-container fl-wrap">
            <div class="row">
                <!--features-box -->
                <div class="col-md-4">
                    <div class="features-box">
                        <div class="time-line-icon">
                            <i class="fal fa-headset"></i>
                        </div>
                        <h3>24 Hours Support</h3>
                    </div>
                </div>
                <!-- features-box end  -->
                <!--features-box -->
                <div class="col-md-4">
                    <div class="features-box">
                        <div class="time-line-icon">
                            <i class="fal fa-users-cog"></i>
                        </div>
                        <h3>Profile Panel</h3>
                    </div>
                </div>
                <!-- features-box end  -->
                <!--features-box -->
                <div class="col-md-4">
                    <div class="features-box ">
                        <div class="time-line-icon">
                            <i class="fal fa-mobile"></i>
                        </div>
                        <h3>Mobile Friendly</h3>
                    </div>
                </div>
                <!-- features-box end  -->
            </div>
        </div>
        <!-- features-box-container end  -->
    </div>
</section>